import './ScrollToBlock.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM } from '../../utils';
import { useHistory } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
const ScrollToBlock = _ref => {
  let {
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const history = useHistory();
  const scrollElemId = params['Anchor Url Parameter'] || '';
  const myRef = React.useRef(null);
  const [ref, inView] = useInView({
    rootMargin: '0px 0px 0px 0px',
    triggerOnce: false
  });
  const [check, setCheck] = React.useState(true);
  React.useEffect(() => {
    if (!inView && check) {
      setTimeout(() => {
        if (myRef && myRef.current) {
          myRef.current.scrollIntoView();
        }
      }, 1000);
      setCheck(false);
    }
  }, [inView]);
  React.useEffect(() => {
    if (canUseDOM) {
      setHref();
    }
    if (myRef && myRef.current) {
      myRef.current.scrollIntoView();
    }
  }, []);
  const setHref = () => {
    if (!scrollElemId) {
      return;
    }
    const scrollElem = document.getElementById(scrollElemId);
    if (!scrollElem) {
      return;
    }

    // history.location.search, if defined, will already include the `?` character, no need to add it.
    const url = `${history.location.pathname}${history.location.search}#${scrollElemId}`;
    // Use `history.push` here instead of `window.location.href` as `window.location.href` will
    // cause the page to "scroll"/jump to the named anchor value and change the browser URL bar.
    // Using just `history.push` will only change the browser URL bar, it doesn't scroll/jump to
    // the named anchor.
    // We need to manually set the scroll position due to header nav being sticky/fixed and obstructing
    // scrolled contents on both mobile and desktop.
    history.push(url);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: `scroll-to-block`
  }, /*#__PURE__*/React.createElement("div", {
    ref: myRef
  }), /*#__PURE__*/React.createElement("div", {
    id: scrollElemId,
    ref: ref
  }));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
const commonStyles = "c8ugvup";
const ltrStyles = "l1dtod0s";
const rtlStyles = "r1q3lrqb";
export default ScrollToBlock;